// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3061f7b1","732":"18588a44","977":"82f0cea1"}[chunkId] + ".chunk.js";
};